import { useTranslation } from 'react-i18next';
import React, { useState, useEffect, useContext } from "react"
import { Tree, Button, Form, Input, message, Upload, Modal } from "antd"
import TopSearch from "@/components/TopSearch"
import { vehicleBrandTree, vehicleBrandInsert, vehicleBrandUpdate, vehicleBrandDelete } from "@/service/dataService"
import { MyContext } from "@/store/myContext"
import { fileUploadUrl, fileLookUrl } from "@/config/app.js"
import { getToken } from "@/utils/dataStorage"
import "./dictStyle.less"



const AllCarTypeManage = () => {
    const { t } = useTranslation();
    const { state } = useContext(MyContext)
    const [form] = Form.useForm()
    const [treeList, setTreeList] = useState(null) //树结构列表
    const [selectTreeObj, setSelectTreeObj] = useState({}) //选择的字典数据
    const [mode, setMode] = useState("edit") //默认展示编辑
    const [settingType, setSettingType] = useState("") //操作的类型

    const [previewVisible, setpreviewVisible] = useState(false) //预览图片使用的dialog
    const [previewImage, setpreviewImage] = useState("") //预览展示的行驶证
    const [licenseFileList, setLicenseFileList] = useState([]) //图片list
    const settingTypeObj = {
        brand: t(`dataManage.vehicleBrand.index.品牌`),
        model: t(`dataManage.vehicleBrand.index.车型`),
    }
    const settingTypeArr = Object.keys(settingTypeObj)
    let pid = ""
    useEffect(() => {
        if (state.activeMenu === "vehicleBrand") {
            loadData()
        }
    }, [state])

    //字典树加载。
    const loadData = () => {
        vehicleBrandTree().then((res) => {
            let result = JSON.parse(
                JSON.stringify(res.retData)
                    .replace(/id/g, "key")
                    .replace(/name/g, "title")
                    .replace(/subItem/g, "children")
            )
            setTreeList(result)
        })
    }

    //选中当前行 根据当前行拿到信息
    const onSelect = (selectedKeys, { node }) => {
        setMode("edit")
        console.log(node)
        if (selectedKeys.length) {
            setSelectTreeObj(node)
            setSettingType(node.type)
            let imgFileList = []
            if (node.logo) {
                //回显图片， 有的话在做回显
                imgFileList = [
                    {
                        uid: "-1",
                        status: "done",
                        url: `${fileLookUrl().image}${node.logo}`,
                    },
                ]
            }
            //回显图片
            setLicenseFileList(imgFileList)
            setpreviewImage(node.logo)
            //编辑回显
            form.setFieldsValue({
                ...node,
                name: node.title,
                logo: imgFileList,
                id: node.key,
            })
        } else {
            setSelectTreeObj({})
            form.resetFields()
        }
    }
    //新增模式
    const handleInsert = (str) => {
        //新增品牌
        if (str === settingTypeArr[0]) {
            //品牌新增
            message.success(t(`dataManage.vehicleBrand.index.品牌新增模式开启`))
            //设置该项为了展示
            setSelectTreeObj({ barndInsert: true })
        } else if (str === settingTypeArr[1]) {
            //新增车型
            if (selectTreeObj.type !== settingTypeArr[0]) {
                message.warning(t(`dataManage.vehicleBrand.index.请选择正确的添加位置`))
                return
            }
            message.success(t(`dataManage.vehicleBrand.index.车型新增模式开启`))
        }
        form.setFieldsValue({
            name: "",
            sort: "",
            logo: [],
        })
        setLicenseFileList([])
        setpreviewImage("")
        setMode("insert")
        setSettingType(str)
    }

    const handleDelete = () => {
        if (!Object.keys(selectTreeObj).length) {
            message.warning(t(`dataManage.vehicleBrand.index.请选择你要操作的选项`))
            return
        }
        const modal = Modal.confirm({
            content: `${t(`dataManage.vehicleBrand.index.确定要删除车辆`)} - ${selectTreeObj.title}?`,
            okText: t(`dataManage.vehicleBrand.index.确定`),
            cancelText: t(`dataManage.vehicleBrand.index.取消`),
            centered: true,
            onOk() {
                const { key: id } = selectTreeObj
                vehicleBrandDelete(id).then((res) => {
                    loadData()
                    setSelectTreeObj({})
                    message.success(`${selectTreeObj.title}:${t(`dataManage.vehicleBrand.index.删除成功`)}`)
                })
            },
        })
    }

    //禁用
    const deleteWv = () => {
        if (!Object.keys(selectTreeObj).length) {
            message.warning(t(`dataManage.vehicleBrand.index.请选择你要操作的选项`))
            return
        }
        const { key: id, title: name, disableFlag, type, parentId, logo, sort } = selectTreeObj
        vehicleBrandUpdate({ id, name, type, parentId, logo, sort, disableFlag: disableFlag === 0 ? 1 : 0 }).then((res) => {
            loadData()
            setSelectTreeObj({})
            message.success(`${selectTreeObj.title}:${t(`dataManage.vehicleBrand.index.操作成功`)}`)
        })
    }
    //字典新增或编辑
    const wvSubmit = () => {
        form.validateFields().then((values) => {
            let data = { ...values, logo: previewImage }
            //新增
            if (mode === "insert") {
                let sendData = {
                    ...data,
                    disableFlag: 0,
                    type: settingType,
                }
                if (settingType === settingTypeArr[0]) {
                    sendData.parentId = null
                } else {
                    sendData.parentId = selectTreeObj.key
                }
                vehicleBrandInsert(sendData).then((res) => {
                    message.success(t(`dataManage.vehicleBrand.index.增加成功`))
                    setMode("edit")
                    loadData()
                })
            } else {
                let sendData = {
                    ...selectTreeObj,
                    ...data,
                    type: settingType,
                    id: selectTreeObj.key,
                }
                //编辑
                vehicleBrandUpdate(sendData).then((res) => {
                    message.success(t(`dataManage.vehicleBrand.index.编辑成功`))
                    loadData()
                })
            }
            setSelectTreeObj({})
        })
    }

    // 图片上传
    const handleImgChange = async (info) => {
        if (info.file.status === "done") {
            let md5 = info?.file?.response?.retData
            setpreviewImage(md5)
            setLicenseFileList(info.fileList)
        } else if (info.file.status === "removed") {
            setLicenseFileList([])
            setpreviewImage("")
        }
    }

    //表单项 布局
    const formItemLayout = {
        labelCol: { span: 6 },
        wrapperCol: { span: 12 },
    }

    const handlePreview = async (file) => {
        setpreviewVisible(true)
    }

    //表单绑定图片
    const normFile = (e) => {
        if (Array.isArray(e)) {
            return e
        }
        return e && e.fileList
    }
    return (
        <>
            {state.activeMenu === "vehicleBrand" && (
                <>
                    <TopSearch title= {t(`dataManage.vehicleBrand.index.车型管理`)} />
                    <div className="dict-container">
                        <div className="dict-list-box">
                            <div className="dict-list-header">
                                <div className="dict-list-name">
                                    <span> {t(`dataManage.vehicleBrand.index.品牌列表`)}</span>
                                </div>
                                <div className="dict-list-but">
                                    <Button type="primary" shape="round" size="small" className="dict-but-left" onClick={() => handleInsert(settingTypeArr[0])}>
                                         {t(`dataManage.vehicleBrand.index.品牌新增`)}
                                    </Button>
                                    <Button type="primary" shape="round" size="small" className="dict-but-left" onClick={() => handleInsert(settingTypeArr[1])}>
                                         {t(`dataManage.vehicleBrand.index.型号新增`)}
                                    </Button>
                                    <Button type="primary" shape="round" size="small" className="dict-but-left" onClick={deleteWv}>
                                        {selectTreeObj.disableFlag ? t(`dataManage.vehicleBrand.index.启用`) : t(`dataManage.vehicleBrand.index.禁用`)}
                                    </Button>
                                    <Button type="primary" shape="round" size="small" className="dict-but-left" onClick={() => handleInsert(handleDelete)}>
                                         {t(`dataManage.vehicleBrand.index.删除`)}
                                    </Button>
                                </div>
                            </div>
                            <div className="dict-table-box">
                                {treeList && <Tree selectedKeys={[selectTreeObj.id || ""]} onSelect={onSelect} treeData={treeList} />}
                            </div>
                        </div>
                        <div className="dict-from-box">
                            {Object.keys(selectTreeObj).length ? (
                                <>
                                    <div className="dict-list-header">
                                        <div className="dict-list-but">
                                            <Button type="primary" shape="round" size="small" className="dict-but-left" onClick={wvSubmit}>
                                                 {t(`dataManage.vehicleBrand.index.保存`)}
                                            </Button>
                                            <Button
                                                type="primary"
                                                shape="round"
                                                size="small"
                                                className="dict-but-left"
                                                onClick={() => {
                                                    setSelectTreeObj({})
                                                    setMode("edit")
                                                }}
                                            >
                                                 {t(`dataManage.vehicleBrand.index.取消`)}
                                            </Button>
                                        </div>
                                    </div>
                                    <div className="dict-from-content">
                                        <Form form={form} {...formItemLayout}>
                                            <Form.Item name="name" label= {t(`dataManage.vehicleBrand.index.名称`)}>
                                                <Input placeholder= {t(`dataManage.vehicleBrand.index.名称`)} />
                                            </Form.Item>
                                            <Form.Item name="sort" label= {t(`dataManage.vehicleBrand.index.排序`)}>
                                                <Input placeholder= {t(`dataManage.vehicleBrand.index.排序`)} />
                                            </Form.Item>
                                            <Form.Item label="logo" name="logo" valuePropName="fileList" getValueFromEvent={normFile}>
                                                <Upload
                                                    action={`${fileUploadUrl}upload/image_old`}
                                                    headers={{ authorization: getToken() }}
                                                    listType="picture-card"
                                                    className="avatar-uploader"
                                                    fileList={licenseFileList}
                                                    onPreview={handlePreview}
                                                    onChange={handleImgChange}
                                                >
                                                    {licenseFileList.length >= 1 ? null : <Button> {t(`dataManage.vehicleBrand.index.上传`)}logo</Button>}
                                                </Upload>
                                            </Form.Item>
                                        </Form>
                                    </div>
                                </>
                            ) : (
                                <div className="dict-init-box">
                                    <span> {t(`dataManage.vehicleBrand.index.品牌列表`)}</span>
                                </div>
                            )}
                        </div>
                    </div>
                    <Modal
                        visible={previewVisible}
                        title={t(`dataManage.vehicleBrand.index.图片查看`)}
                        footer={null}
                        onCancel={() => setpreviewVisible(false)}
                        onOk={() => setpreviewVisible(false)}
                    >
                        <img alt="" style={{ width: "100%" }} src={`${fileLookUrl().image}${previewImage}`} />
                    </Modal>
                </>
            )}
        </>
    )
}
export default AllCarTypeManage
